export enum TaskStatus {
    New,
    Waiting,
    Running,
    Completed,
    Failed,
    FailedRetry
}

export interface ITask {
    taskId: string;
    createdOn: Date;
    typeName: string;
    methodName: string;
    parameter: string;
    maxRetryCount: number;
    status: TaskStatus;
    statusDate: Date;
    retryCount: number;
    retryTime?: Date;
    runMilliseconds?: number;
    result: string;
    error: string;
    statusDescription: string;
    instanceId: string;
}